import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import UIListenerHelper from '@/UIListener/UIListenerHelper';
import ListViewViewModel from '@/ViewModels/Views/ListViewViewModel';
import RADApplication from '@/Management/RADApplication';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import * as CoreFrameDTOs from "coreframetypings/dto";
import NavigationHelper from '@/Management/NavigationHelper';

export default class TaskUIListenerHelper  {

    public static onBeforeRender(context: DetailViewContext): void {
        TaskUIListenerHelper.removeJournalExpander(context);
        TaskUIListenerHelper.setTaskCssClass(false);
        TaskUIListenerHelper.hideOperations(context);
        TaskUIListenerHelper.convertTabGroupToPropertyGroup(context, '.PRIMARYINPUTOBJECT');
    }

    public static onBeforeRenderSummaryView(context: DetailViewContext): void {
        TaskUIListenerHelper.removeJournalExpander(context);
    }

    public static onSummaryViewReady(context: DetailViewContext): void {
        TaskUIListenerHelper.setTaskCssClassImmediately(true);
    }

    public static onBeforeCallOperation(context: DetailViewContext | ListViewViewModel, operation: string): boolean | JQueryPromise<boolean> {
        if (operation === 'AssignToCurrentUserInDetailView') {
            return TaskUIListenerHelper.checkPendingModifications(context as DetailViewContext);
        }

        if (operation === 'ReleaseAssignmentInDetailView') {
            return TaskUIListenerHelper.checkPendingModifications(context as DetailViewContext);
        }

        return null;
    }

    private static convertTabGroupToPropertyGroup(context: DetailViewContext, dvgPostfix: string): void {
        const detailViewGroups = context.detailViewContextDTO?.detailView?.detailViewGroups;
        const tabProcessingGroup = detailViewGroups.filter(gr => gr.name.endsWith(dvgPostfix))[0];

        if (tabProcessingGroup && tabProcessingGroup.detailViewGroups.length === 0)
            tabProcessingGroup.uiGenerator = "PropertyGroup?Layout=OneColumnLayout";
    }

    private static checkPendingModifications(context: DetailViewContext): boolean | JQueryPromise<boolean> {
        if (!context.detailViewContextDTO.hasWriteRight || !context.hasPendingModifications())
            return true;

        var deferred = $.Deferred();

        const messageBoxViewModel = MessageBoxViewModel.createSaveWarningMessageBox(() => {
            context.apply()
                .then((result) => deferred.resolve(result));
        }, () => {
            deferred.resolve(false);
        });

        messageBoxViewModel.window.allowClose(false);

        RADApplication.getInstance().showMessageBox(messageBoxViewModel);
        return deferred.promise();
    }

    public static onAfterCallOperation(context: DetailViewContext | ListViewViewModel, operation: string, args: CoreFrameDTOs.IOperationResultDTO): boolean {
        if (operation === 'AssignToCurrentUserInDetailView') {
            if (TaskUIListenerHelper.checkResult(args)) {
                const dvContext = context as DetailViewContext;
                const pdoId = dvContext.genericObject.pdoId;
                dvContext.apply().then((result) => {
                    if (result) {
                        NavigationHelper.openDetailView('EDIT', 'RAD.RADFoundation.ProblemDomain.PDTask', {
                            pdoId: pdoId,
                        });
                    }
                });
            }
            return true;
        }
        else if (operation === 'ReleaseAssignmentInDetailView') {
            if (TaskUIListenerHelper.checkResult(args)) {
                const dvContext = context as DetailViewContext;
                dvContext.save();
            }
            return true;
        }

        return false;
    }

    private static checkResult(args: CoreFrameDTOs.IOperationResultDTO): boolean {
        return args != null && args.isValid && args.status === 'Successfull';
    }

    private static hideOperations(context: DetailViewContext): void {
        const showAssignOp = context.genericObject.getValue<boolean>('ShowAssignOp');
        if (!showAssignOp)
            TaskUIListenerHelper.hideOperation(context, 'AssignToCurrentUserInDetailView');

        const showReleaseOp = context.genericObject.getValue<boolean>('ShowReleaseOp');
        if (!showReleaseOp)
            TaskUIListenerHelper.hideOperation(context, 'ReleaseAssignmentInDetailView');
    }

    private static hideOperation(context: DetailViewContext, name: string): void {
        const linksObs = context.toolBar?.secondary;
        if (!linksObs)
            return;

        const filteredLinks = linksObs().filter(x => x.technicalName === name);
        for (let link of filteredLinks) {
            link.isVisible(false);
        }
    }

    /**
     * Ziel ist, dass der Expander, der das Eingabeobjekt visuell vom Task trennt, nicht sichtbar ist.
     * Da die DVGroups nicht einfach in den Hauptcontext verschoben werden können (eigenes DTO für die DetailView)
     * muss der Expander über das Template ausgeblendet werden, hierfür wird eine CSS-Klasse gesetzt
     */
    private static setTaskCssClass(summaryView: boolean) {
        TaskUIListenerHelper.setTaskCssClassImmediately(summaryView);
    }

    private static setTaskCssClassImmediately(summaryView: boolean) {
        const className = summaryView ? 'propertygroupbox' : 'detailviewgroupbox';
        $('.c-' + className).addClass('task-dv');
    }

    private static removeJournalExpander(context: DetailViewContext) {
        const pdTypeName = context.getConcretePdTypeName();

        UIListenerHelper.removeDetailViewGroupDto(context, `${pdTypeName}.METADATA`);
    }
}